import _ from 'underscore';
import ko from 'knockout';
import { BID_MODE } from './bid-mode';
import { BidLandscapeBaseViewModel } from '../base-viewmodel';
import { AdGroupBidTypeNames } from './adgroup-bid-type-names';

export class AdGroupBidLandscapeViewModel extends BidLandscapeBaseViewModel {
  constructor({
    parentItem,
    parentView,
    i18n,
    entityType = 'adgroup',
    inSimpleMode,
    dataToShow,
    inKeywordCreationWorkflow,
  }) {
    super({
      parentItem, parentView, i18n, entityType, inSimpleMode, dataToShow,
    });

    this.uniformData = ko.observable({ dataArray: [], selectedIndex: 0 });
    this.defaultData = ko.observable({ dataArray: [], selectedIndex: 0 });

    this.inKeywordCreationWorkflow = inKeywordCreationWorkflow;

    this.hasUnformBidData = ko.pureComputed(() => !_.isEmpty(this.uniformData().dataArray));

    this.hasDefaultBidData = ko.pureComputed(() =>
      (!_.isEmpty(this.defaultData().dataArray) && !this.inKeywordCreationWorkflow));

    this.adgroupSelectMode = ko.observable(BID_MODE.NONE);
    this.customBidCurrentPoint = ko.observable({});
    this.clearBid = ko.observable(false);

    const dataForBidType = dataToShow.DefaultResult || dataToShow.UniformData;
    const bidType = dataForBidType ? dataForBidType.AdGroupBidType : 0;
    this.bidType = AdGroupBidTypeNames[bidType];

    this.adgroupSelectMode.subscribe((newValue) => {
      if (newValue === BID_MODE.UPDATE_DEFAULT) {
        this.dataArray(this.defaultData().dataArray);
        this.clearBid(false);
        this.currentSelectedId(this.defaultData().selectedIndex);
      } else if (newValue === BID_MODE.CLEAR_KEYWORD) {
        this.dataArray(this.uniformData().dataArray);
        this.clearBid(true);
        this.currentSelectedId(this.uniformData().selectedIndex);
      }
    });

    this.tableBidText = ko.computed(() => {
      if (this.clearBid()) {
        return i18n.getString(parentItem.isDSA ? 'Adgroup_kpiMaxCpc4Uniform_DSA' : 'Adgroup_kpiMaxCpc4Uniform');
      }
      return i18n.getString('Adgroup_kpiMaxCpC');
    });

    // Override the convert data for bidlanscape function
    // adgroup bid landscape support two kinds of data & selection to jump between them
    this.convertDataForBidLandscape = () => {
      if (!this.inKeywordCreationWorkflow) {
        this.defaultData(this.convertDataForChart(dataToShow.DefaultResult));
      }
      this.uniformData(this.convertDataForChart(dataToShow.UniformData, true));

      if (this.hasDefaultBidData() || this.hasUnformBidData()) {
        const data = this.hasDefaultBidData() ? this.defaultData() : this.uniformData();
        const dataToShowForLandscape = this.hasDefaultBidData() ?
          dataToShow.DefaultResult :
          dataToShow.UniformData;

        this.adgroupSelectMode(this.hasDefaultBidData() ?
          BID_MODE.UPDATE_DEFAULT :
          BID_MODE.CLEAR_KEYWORD);
        this.isClickGraph(data.showClick);
        this.startDateString(dataToShowForLandscape.StartDateString);
        this.endDateString(dataToShowForLandscape.EndDateString);
      }
    };

    this.needCostColumn = ko.computed(() => this.bidType === 'CPM' || (this.bidType === 'CPV' && !this.isClickGraph()));
  }

  updateAdgroupSelectedMode(newSelction) {
    const updateDefault = newSelction === BID_MODE.UPDATE_DEFAULT && this.hasDefaultBidData();
    const updateUniform = newSelction === BID_MODE.CLEAR_KEYWORD && this.hasUnformBidData();

    if (updateDefault || updateUniform) {
      this.adgroupSelectMode(newSelction);
      return true;
    }

    return false;
  }
}
